module.exports = __webpack_public_path__ + "img/case5.3f7e3e47.png";